import React from 'react'
import PropTypes from 'prop-types'
import isEqual from 'lodash/isEqual'

const FilterControlItemComponent = ({
  ControlWrapper,
  Component,
  className,
  name,
  values,
  value,
  onApply,
  filterManager,
}) => (
  <ControlWrapper>
    <Component
      className={className}
      name={name}
      filterManager={filterManager}
      {...values}
      value={value}
      onApply={onApply}
    />
  </ControlWrapper>
)

FilterControlItemComponent.propTypes = {
  ControlWrapper: PropTypes.elementType.isRequired,
  Component: PropTypes.elementType.isRequired,
  className: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  values: PropTypes.object.isRequired,
  value: PropTypes.any,
  onApply: PropTypes.func.isRequired,
  filterManager: PropTypes.object.isRequired,
}

const areFilterControlItemPropsEqual = (prevProps, nextProps) =>
  isEqual(prevProps.value, nextProps.value) &&
  isEqual(prevProps.values, nextProps.values) &&
  prevProps.className === nextProps.className &&
  prevProps.name === nextProps.name &&
  prevProps.onApply === nextProps.onApply &&
  prevProps.Component === nextProps.Component

const FilterControlItem = React.memo(FilterControlItemComponent, areFilterControlItemPropsEqual)

export default FilterControlItem
